import React, {useState} from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
//import imgCEON from '../img/CEOInst_Name.png';
//import imgCEOC from '../img/CEOInst_Content.png';
import imgCEOHeader from '../img/Header.png';
import imgCEOFooter from '../img/Footer.png';
import imgCEO from '../img/sotec_img_ceo.png';
import imgCEOSign from '../img/img_ceo_sign.png';
import Header from '../../../common/Header_White_Base.js'
import Footer from  '../../../common/Footer.js'
import Text from '../../../common/Text.js'
// import LinearGradient from 'react-native-linear-gradient';
// import {StyleSheet, Text} from 'react-naive';
import '../css/CEOInst.css'

function CEOInst() {
    const [Display, setDisplay] = useState('none');
    const [remainingHeight, setRemainingHeight] = useState(0);
    const handleHover = (height) => {
        setRemainingHeight(height);
        console.log('Received Remaining height:', height);
        setDisplay('block');
        console.log('Received Remaining height:', Display);

    };
    const handleHoverEnd = () => {
        console.log('Hover ended in MainComponent');
        setDisplay('none');
    };

     return (
         <div>
            {/* <header> <Header class = 'header1' onHover={handleHover} onHoverEnd={handleHoverEnd}/>
            <div style={{ zIndex:2, display:Display,position: 'fixed', bottom: 0, left: 0, right: 0, height:remainingHeight, backgroundColor:'black', width:'100%', opacity:0.6}}/> 
            </header> */}
            {/* <Header onHover={handleHover} onHoverEnd={handleHoverEnd}/>
            <div style={{ zIndex:2, display:Display,position: 'fixed', bottom: 0, left: 0, right: 0, height:remainingHeight, backgroundColor:'black', width:'100%', opacity:0.6}}/> */}
            {/* <div className='CEOHeader'><img src={imgCEOHeader}/></div> */}
            <div className='CEOMain'>
                    {/* <div className='CEOparent1'> */}
                        <div className='CEOBody1'>
                            {/* <div className='CEOHello'>CEO 인사말</div> */}
                            <Text variant='titlename' className='CEOHello'>CEO 인사말</Text>
                            <div className='CEOrectangle1'></div>  
                        </div>  
                        {/* <div className='CEOBody2'> 
                            최고의 기술로, 안전한 바다를 설계합니다.
                        </div> */}
                    {/* </div> */}
                        <div className='CEOBody3'>
                            <Text variant='px32w700B' >최고의 기술로, 안전한 바다를 설계합니다.</Text>
                            <Text variant='px20' style={{fontWeight:'500'}}>
                                <div className='CEOContent1'>쏘테크 홈페이지를 찾아주셔서 감사합니다.</div>
                                    <div className='CEOContent2'>쏘테크는 설계, 품질 검사, ICT 시스템 개발 등의 분야에서 최고의 품질과 혁신적인 기술력으로,<br/>
                                                                고객 맞춤형 솔루션을 제공하고 있습니다.<br/>                     
                                    </div>
                                    <div className='CEOContent9'>앞으로도 쏘테크는 기술 혁신과 글로벌 경쟁력 강화를 지속적으로 추진하여,<br/>
                                                                고객과의 신뢰를 더욱 공고히 하겠습니다.
                                    </div>
                                    <div className='CEOContent3'>또한, 쏘테크는 안전과 환경을 최우선으로 고려한 지속 가능한 솔루션을 제공하며,<br/>
                                                                고객과 사회에 기여하는 기업으로서의 책임을 다하고 있습니다.
                                    </div>
                                    <div className='CEOContent4'>앞으로도 쏘테크는 지속 가능한 미래를 위한 조선해양 산업을 만들어 나가는 데<br/>
                                                                최선을 다할 것을 약속 드립니다.
                                    </div>
                                    <div className='CEOContent5'>감사합니다.
                                </div>
                            </Text>
                        </div>
                        <div className='CEOBody4'>
                            <Text variant='px20' className='CEOContent6' >대표이사</Text>
                            <div className='CEOContent7'><img src={imgCEOSign} /></div>
                            <div className='CEOContent8'><img src={imgCEO}  /></div>
                        </div>
            </div>
            {/* <div className='CEOFooter'><img src={imgCEOFooter}/></div> */}
            {/* <Footer /> */}
         </div>
     );
 }
 
 export default CEOInst;